module.exports = __webpack_public_path__ + "static/media/imagemMarcacaoRegister.d32f8e44.jpg";